import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import useTheme from "hooks/useTheme";

import UserIconRoundIcon from "theme/icons/UserIconRound";
import RefreshIcon from "theme/icons/Refresh";
import BugIcon from "theme/icons/Bug";
import QuestionMarkIcon from "theme/icons/QuestionMark";
import NotificationsIcon from "theme/icons/Notifications";
import { getUserProfile } from "actions/profile";
import useRefresh from "hooks/useRefresh";

function Header() {
	const dispatch = useDispatch();
	const { themeColor } = useTheme();
	const { setIsRefresh } = useRefresh();

	const algoChain = useSelector((state) => state.AppPreferences?.algoChain);
	const profile = useSelector((state) => state.Profile);
	const fetchingDataFromApi = useSelector((state) => state.FetchingDataFromApi);

	useEffect(() => {
		dispatch(getUserProfile());

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<nav className={`flex h-10 items-center justify-between mt-2 mb-4 px-4 2xl:px-56 xl:px-32`}>
			<div className="w-fit flex items-center justify-center md:justify-start cursor-pointer">
				<Link className="w-fit flex items-center space-x-2" to="/">
					<img className="md:w-6 2xl:w-8" src={`${process.env.PUBLIC_URL}/media/logo.png`} alt="logo" />
					<div className="flex">
						<h1 className={`xl:text-xl 2xl:text-2xl ${themeColor?.text}`}>Daffi</h1>
						<h1 className={`xl:text-xl 2xl:text-2xl italic ${themeColor?.text}`}>Wallet</h1>
					</div>
				</Link>
			</div>

			<div className="w-full flex items-center justify-end space-x-8">
				<RefreshIcon
					onClick={() => setIsRefresh(true)}
					className={`w-4 ${fetchingDataFromApi && "animate-spin"} cursor-pointer smooth hover:shadow-xl`}
					fill={themeColor?.hex}
				/>

				<div className="w-fit flex items-center space-x-1">
					<p className={`text-md font-medium capitalize ${themeColor?.text}`}>{algoChain.slice(0, 1)}</p>
				</div>

				<div className="flex items-center justify-center space-x-3">
					<BugIcon
						className={`w-5 cursor-pointer`}
						fill={themeColor?.hex}
						onClick={() =>
							window.open(
								`https://forms.zohopublic.com/rdinitiativ/form/DaffiWalletAndroidBugReporting/formperma/PNWlpyq9SYqu9OBAJmqXsVVQ-Xs6OVznVGCecia_pj0`,
								"_blank"
							)
						}
					/>
					<QuestionMarkIcon
						className={`w-5 h-5 cursor-pointer rounded-full p-1 ${themeColor?.bg}`}
						fill="#FFFFFF"
						onClick={() => window.open("https://desk.daffi.me/portal/en/kb/daffi", "_blank")}
					/>
				</div>

				<div className="flex items-center justify-center space-x-3">
					<NotificationsIcon className={`w-5`} fill={themeColor?.hex} />

					<Link to="/Profile">
						{profile?.["profile-image"] ? (
							<img
								className={`w-8 h-8 object-cover object-center rounded-2xl`}
								src={profile["profile-image"]}
								alt="temp"
							/>
						) : (
							<UserIconRoundIcon className={`w-5`} fill={themeColor?.hex} />
						)}
					</Link>
				</div>
			</div>
		</nav>
	);
}

export default Header;
